import { atom } from 'recoil';

const isSideMenuOpenState = atom({
  key: 'isSideMenuOpen',
  default: false,
});

export default isSideMenuOpenState